import { Breadcrumbs, Link as MuiLink, Tooltip } from "@mui/material";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";

import type { TreeViewItem } from "../utils";
import type { FC } from "react";

export const FolderBreadcrumb: FC<{
  breadcrumbs: TreeViewItem[];
  onFolderSelect: (folderId: string) => void;
}> = ({ breadcrumbs, onFolderSelect }) => (
  <Breadcrumbs separator="/">
    {breadcrumbs.map((breadcrumb, index) => (
      <BreadcrumbLink
        key={breadcrumb.id}
        breadcrumb={breadcrumb}
        isLast={index === breadcrumbs.length - 1}
        onFolderSelect={onFolderSelect}
      />
    ))}
  </Breadcrumbs>
);

const BreadcrumbLink: FC<{
  breadcrumb: TreeViewItem;
  isLast: boolean;
  onFolderSelect: (folderId: string) => void;
}> = ({ breadcrumb, isLast, onFolderSelect }) => {
  const shouldTruncate = breadcrumb.label.length > 16;

  return (
    <ConditionalWrapper
      condition={shouldTruncate}
      wrapper={(children) => (
        <Tooltip title={breadcrumb.label} enterDelay={500} placement="top">
          {children}
        </Tooltip>
      )}
    >
      <MuiLink
        component="button"
        underline="none"
        onClick={isLast ? undefined : () => onFolderSelect(breadcrumb.id)}
        sx={{
          cursor: isLast ? "default" : "pointer",
          ...(shouldTruncate && {
            maxWidth: 200,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            display: "block",
          }),
        }}
        color={isLast ? "inherit" : "primary.main"}
      >
        {breadcrumb.label}
      </MuiLink>
    </ConditionalWrapper>
  );
};
